import templateUrl from 'emun.salesrep/inside-sales-count.htm';
//import AutoQuery from 'servicestack/auto-query/auto-query';
import basicController from 'servicestack/basic.controller.properties';
//import resolve from 'ioc/resolve';

class InsideSalesCountController {
  constructor($rootScope, createAutoQuery) {
    const $ctrl = this;
    basicController($ctrl);
    var context = $ctrl.context || "rep";
    var filterType = '';

    if (context === 'manager') {
      filterType = '&ManagerId=' + $ctrl.repId;
    }

    var getDataUrl = 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesYearToDate,TotalSalesYearToDateLastYear&IsInsideSales=true&GroupBy=WritingRepId,WritingRepName&OrderBy=WritingRepName' + filterType;
    $ctrl.InsideSalesCountCalulatedData = [];
    $ctrl.InsideSalesCountData = new createAutoQuery({
      url: getDataUrl,
      autoLoad: true,
      pageSize: 100,
      scrollTop: false,
      onLoaded: function (resultsOrderTotals) {
        resultsOrderTotals.results.forEach(function (OrderTotalItem) {
          var obj = {};

          obj.WritingRep = OrderTotalItem.writingRepName;
          obj.sumTotalSalesMonthToDate = OrderTotalItem.sumTotalSalesMonthToDate.toFixed(2);
          obj.monthGoal = 0;
          obj.sumTotalSalesMonthToDateLastYear = OrderTotalItem.sumTotalSalesMonthToDateLastYear.toFixed(2);
          obj.sumTotalSalesYearToDate = OrderTotalItem.sumTotalSalesYearToDate.toFixed(2);
          obj.yearGoal = 0;
          obj.sumTotalSalesYearToDateLastYear = OrderTotalItem.sumTotalSalesYearToDateLastYear.toFixed(2);

          if (context === 'executive') { //pull the rep goals directly from the table by the writing rep ID
            $ctrl.goalsQuery = createAutoQuery({
              url: 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&IsInsideSales=True&GroupBy=vendorID&SalesRepID=' + OrderTotalItem.writingRepId,
              autoLoad: true,
              pageSize: 1000,
              onLoaded: function (args) {
                if (args.total > 0) {
                  args.results.forEach(function (res) {
                    obj.monthGoal = Math.round(res.sumSalesGoalThisMonth);
                    obj.yearGoal = Math.round(res.sumSalesGoalThisYear);
                  });
                }
              }
            });
          } else { //manager
            var loopFilterType = '';
            loopFilterType = filterType + '&WritingRepId=' + OrderTotalItem.writingRepId; //pass in the specific writing rep ID we need to look up goals for
            $ctrl.goalsQuery = createAutoQuery({
              url: 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter,RepInsideSalesGoalThisMonth,RepInsideSalesGoalThisYear,RepInsideSalesGoalLastYear,RepInsideSalesGoalLastMonth,RepInsideSalesGoalThisQuarter&IsInsideSales=True&GroupBy=vendorID' + loopFilterType,
              autoLoad: true,
              pageSize: 1000,
              onLoaded: function (args) {
                if (args.total > 0) {
                  args.results.forEach(function (res) {
                    obj.monthGoal = Math.round(res.sumRepInsideSalesGoalThisMonth);
                    obj.yearGoal = Math.round(res.sumRepInsideSalesGoalThisYear);
                  });
                }
              }
            });
          }
          $ctrl.InsideSalesCountCalulatedData.push(obj);
        });//for each loop
      }
    });
  }
}

let InsideSalesCount = {
  bindings: {
    repId: '@',
    repGroup: '@',
    context: '@',
    rep: '<',
    insideSales: '@',
    writingRepId: '@'
  },
  controller: InsideSalesCountController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default InsideSalesCount;